import { useNumberFormat } from '@enterprise/hooks';

import type { NumberFormatProps } from '#formats/types/number-format.props';

/**
 * Formats and displays a number according to the specified number of decimals.
 * Uses the `useNumberFormat` hook to format the value.
 *
 * @param decimals - The number of decimal places to display.
 * @param value - The numeric value to format.
 * @param props - Additional props to spread onto the underlying <span> element.
 * @returns A <span> element containing the formatted number.
 */
export const NumberFormat = ({ decimals, fallback = '?', value, ...props }: NumberFormatProps) => {
  return <span {...props}>{useNumberFormat(value, decimals, fallback)}</span>;
};
